import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { ModuleFE_AdvisorStatic } from '../ModuleFE_AdvisorStatic.js';
import { DBDef_FHIRQuery } from '@app/fhir-shared';
export const dispatch_onFHIRQueryChanged = new ThunderDispatcherV3('__onFHIRQueryUpdated');
class ModuleFE_Advisor_FHIRQuery_Class extends ModuleFE_AdvisorStatic {
    constructor() {
        super(DBDef_FHIRQuery, dispatch_onFHIRQueryChanged);
    }
}
export const ModuleFE_Advisor_FHIRQuery = new ModuleFE_Advisor_FHIRQuery_Class();
export const ModulePack_Static_FHIR = [ModuleFE_Advisor_FHIRQuery];
//# sourceMappingURL=fhir.js.map